export class ReturnMessageDTO {
  transactionId: number;
  activityIds: number[];
  claimedAmountProductCurrency: number;
  benefitAmountProductCurrency: number;
  duration: number;
  missedPayments: number;
  shortPaid: number;
  message: string;
  result: boolean;

  // Front-end Managed fields
  claimType: string;
  isProviderPortal: boolean;
}
